import $ from 'jquery';
import 'slick-carousel';

const defaults = {
  arrows: false,
  slide: '.views-row',
  slidesToShow: 3,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        dots: true,
        slidesToShow: 1,
        centerMode: true,
        centerPadding: '50px',
      },
    },
  ],
};

function FeaturedSlider(element, options) {
  this.element = element;
  this.$element = $(element);
  this.settings = { ...defaults, ...options };
  this.$slickContainer = this.addSlick();
  this.ready();
}

FeaturedSlider.prototype = {
  addSlick() {
    return this.$element.find('.view-content').slick(this.settings);
  },
  ready() {
    this.$element.addClass('ready');
  },
};

export default FeaturedSlider;



// WEBPACK FOOTER //
// ./FeaturedSlider.js